









































































































































import { Component, Vue } from "vue-property-decorator";
import {
  getArticles,
  addEquipment,
  editForm,
  getinfo,
} from "@/api/equiptypeManage";
import Pagination from "@/components/Pagination/index.vue";
@Component({
  name: "equiptypeManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery);
  }
  private currtentpage = 1;
  private total: number = 0;
  private formObj = {
    dialogVisible: false,
  };
  private options = [
    {
      key: "启用",
      value: 1,
    },
    {
      key: "禁用",
      value: 0,
    },
  ];
  private tableData = {};
  private currentPage: number = 1;
  private value: boolean = true;
  private isloading = true;
  private isuse = 1;
  private addParams: any = {
    name: "",
    description: "",
    isuse: "",
  };
  private editparms: any = {
    // name: "",
    // description: "",
    // isuse: "",
    // id: "",
    // isdelete: "",
  };
  private listQuery = {
    name: "",
    page: 1,
    limit: 10,
  };
  // 表单校验规则
  private rules = {
    name: [
      { required: true, message: "请输入器材名称", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    description: [
      { required: true, message: "请输入备注内容", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    isuse: [{ required: true, message: "请选择使用状态", trigger: "change" }],
  };

  // 获取列表
  private async getList(params: any) {
    await getArticles(params)
      .then((res) => {
        if (res.code === 200) {
          this.isloading = false;
          res.data.items.forEach((item: any) => {
            item.isuse = item.isuse == 1 ? true : false;
          });
          this.tableData = res.data;
          this.total = res.data.total;
          this.listLoading = false;
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      });
  }
  private async changeSwitch(parms: any) {
    const usestate = parms.isuse === true ? 1 : 0;
    const param = {
      id: parms.id,
    };
    await getinfo(param).then(async (res) => {
      if (res.code === 200) {
        this.editparms = res.data;
        this.editparms.isuse = usestate;
        this.editparms.isdelete = 1;
        await editForm(this.editparms).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              message: "状态更改成功",
              type: "success",
            });
            this.editparms = {};
          } else {
            this.$message({
              message: "状态更改失败",
              type: "warning",
            });
          }
        });
      }
    });
  }
  private async deletedata(params: any) {
    console.log(params);
    this.editparms.isdelete = 0;
    this.editparms.id = params.id;
    this.$confirm("此操作将删除器材" + params + ", 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(async () => {
      await editForm(this.editparms).then((res: any) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList(this.listQuery);
          this.editparms = {
            name: "",
            description: "",
            isuse: "",
            id: "",
            isdelete: 1,
          };
        } else {
          this.$message({
            message: "删除失败",
            type: "warning",
          });
        }
      });
    });
  }
  private onSubmit() {
    this.getList(this.listQuery);
  }
  private clearSearch() {
    this.listQuery.name = "";
    this.getList(this.listQuery);
  }
  private onCreatItem() {
    this.isuse = 1;
    this.addParams = {
      name: "",
      description: "",
      isuse: "",
      organId: "",
    };
    this.formObj.dialogVisible = true;
    this.$nextTick(() => {
      (this.$refs.ruleForm as any).resetFields();
    });
  }

  private async editItem(params: any) {
    const parm = { id: params };
    await getinfo(parm).then((res: any) => {
      if (res.code === 200) {
        this.isloading = false;
        this.addParams = res.data;
        this.isuse = res.data.isuse;
        this.editparms = res.data;
      }
    });
    this.formObj.dialogVisible = true;
  }

  private handleClose(done: any) {
    this.formObj.dialogVisible = false;
    this.addParams = {
      name: "",
      description: "",
      isuse: "",
    };
  }

  private async subMitData() {
    const form = this.$refs.ruleForm as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        if (this.editparms.id) {
          this.editparms.isdelete = 1;
          this.editparms.isuse = this.isuse;
          await editForm(this.editparms).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.$message.success("修改成功");
              this.getList(this.listQuery);
            }
          });
        } else {
          this.addParams.isuse = this.isuse;
          await addEquipment(this.addParams).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.$message.success("添加成功");
              this.getList(this.listQuery);
              this.addParams = {
                name: "",
                description: "",
                isuse: "",
              };
            }
          });
        }
      } else {
        return false;
      }
    });
  }
  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getList(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getList(this.listQuery);
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
